export const APA_ACHIEVEMENT_SUBMISSION_TYPE_REQUEST = 'APA_ACHIEVEMENT_SUBMISSION_TYPE_REQUEST';
export const APA_ACHIEVEMENT_SUBMISSION_TYPE_SUCCESS = 'APA_ACHIEVEMENT_SUBMISSION_TYPE_SUCCESS';
export const APA_ACHIEVEMENT_SUBMISSION_TYPE_FAIL    = 'APA_ACHIEVEMENT_SUBMISSION_TYPE_FAIL';

